/* eslint-disable react/display-name */
import React, { useMemo, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import _, { isEqual } from 'lodash';
import { usePaymentMovementsUIContext } from '../context/PaymentMovementsUIContext';
import { getObjectUrl, prepareFilter, setOrDeleteParams } from '../../../../helpers';
import { FiltersSection } from '../../../../components';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import { useHistory } from 'react-router';
import propertiesToFilter from '../../../../constants/paymentMovements/filters/propertiesToFilter';
import ConfirmModal from '../../../movements/list/modal/ConfirmModal';
import { useTranslation } from 'react-i18next';
import ClientsFiltersModal from '../../../clients/list/ClientsFiltersModal';

// Helpers. (Any state afected on this functions)

const { initialFilter } = UIHelpers();

const firstPage = 1;
const initialLabel = [{ id: 0, property: { type: 'text', label: '' }, value: '' }];
const defaultUserSearchText = {
    status: '',
    level: '',
};

const PaymentMovementsFilters = forwardRef((props, ref) => {
    const { t } = useTranslation();

    // Context State
    const paymentMovementsUIContext = usePaymentMovementsUIContext();
    const paymentMovementsUIProps = useMemo(() => {
        return {
            isLoading: paymentMovementsUIContext.isLoading,
            setIsLoading: paymentMovementsUIContext.setIsLoading,
            queryParams: paymentMovementsUIContext.queryParams,
            setQueryParams: paymentMovementsUIContext.setQueryParams,
        };
    }, [paymentMovementsUIContext]);

    // States
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    // input search state
    const [search, setSearch] = useState('');

    const [filtersList, setFiltersList] = useState(initialLabel);
    const [date, setDate] = useState([]);

    const [searchText, setSearchText] = useState(defaultUserSearchText);
    // Modal state filter
    const [showFiltersDialog, setShowFiltersDialog] = useState(false);
    const [filtersCount, setFiltersCount] = useState(0);

    // Const
    const typesToFilter = propertiesToFilter;
    const propertiesToLike = ['order_id', 'external_id', 'document', 'amount'];

    // URL Search Params
    const params = new URLSearchParams(window.location.search);
    // This is so that the url can be updated after there are changes in the table props
    // Hooks
    const history = useHistory();

    // Reset
    const reset = () => {
        history.push(`${window.location.pathname}`);
        initialFilter.url = window.location.pathname;
        paymentMovementsUIProps.setQueryParams(initialFilter);
        setFiltersList(initialLabel);
        setSearch('');
        setDate([]);
    };
    useImperativeHandle(ref, () => ({
        reset
    }));

    // Handlers
    const handleCleanFilters = () => {
        history.push(`${window.location.pathname}`);
        initialFilter.url = window.location.pathname;
        paymentMovementsUIProps.setQueryParams(initialFilter);
        setFiltersList([{ id: 0, property: { type: 'text', label: '' }, value: '' }]);
        setDate([]);
    };

    const handleAddFilter = () => {
        setFiltersCount(filtersCount + 1);

        const newFilters = [...filtersList];
        newFilters.push({ id: filtersCount, property: { type: 'text', label: '' }, value: '' });

        setFiltersList(newFilters);
    };
    const handleRemoveFilter = id => {
        if (filtersList.length === 1) {
            return undefined;
        }
        setFiltersList(_.remove(filtersList, filter => filter.id !== id));
    };
    const handleFilterInputChange = (property, value, id) => {
        const newFilters = [...filtersList];
        newFilters.map(filter => {
            if (filter.id === id) {
                filter.value = value;
                filter.property = property;
            }
            else {
                newFilters.push({ id, property, value });
            }

            return filter;
        });
        setFiltersList(newFilters);
    };

    const handleSearch = () => {
        // URL
        // OnClick URL and useContext is updating
        changeURL(filtersList);
        // handleFilterSearch with 1 to reset number page
        handleFilterSearch(filtersList, { dateFrom: date[0], dateTo: date[1] }, search, firstPage);
        // close modal
        setShowFiltersDialog(false);
    };

    const handleFilterSearch = (filters, dates, inputText, numberPage) => {
        inputText = inputText.replace(/[.]/g, '');
        inputText = inputText.replace(/[,]/g, '.');
        const sortedFilters = filters.length && filters.sort((filter1, filter2) => {
            if (filter1.property.isIndexed) {
                return -1;
            }
            if (filter2.property.isIndexed) {
                return 1;
            }
            return 0;
        });

        // Prepare filter 'search'
        const newQueryParams = prepareFilter(paymentMovementsUIProps.queryParams, sortedFilters, dates);
        propertiesToLike.forEach(property => {
            newQueryParams.filters.like(property, `${inputText}`);
        });

        // Search activated with filter changes
        const searchPressed = !isEqual(newQueryParams, paymentMovementsUIProps.queryParams);

        if (searchPressed) {
            numberPage && (newQueryParams.pageNumber = numberPage);
            newQueryParams.url = window.location.href;
            // update list by queryParams
            paymentMovementsUIProps.setQueryParams(newQueryParams);
        }
    };

    // Add filter 'search' into params
    const searchInputText = (params) => {
        setOrDeleteParams(params, 'search', search);
    };

    // 1) Desde la url lleno los estados
    const uniqueFilter = () => {
        const url = getObjectUrl(params, { ...searchText, search: '' }, { ...defaultUserSearchText, search: '' });
        url.dateFrom
            ? setDate([url.dateFrom, url.dateTo])
            : setDate([]);

        url.dateTo
            ? setDate([url.dateFrom, url.dateTo])
            : setDate([]);
        // For input 'search'
        url.search !== undefined ? setSearch(url.search) : setSearch('');
        const inputText = url.search ? url.search : '';
        // For modal
        const filterListUpdated = getFilterListByURL(url);
        const newInitialLabel = [...initialLabel];
        setFiltersList(filterListUpdated.length ? filterListUpdated : newInitialLabel);

        // apply filters
        handleFilterSearch(filterListUpdated, { dateFrom: url.dateFrom, dateTo: url.dateTo }, inputText);
    };

    const getFilterListByURL = (url) => {
        const list = [];
        let i = 0;

        for (const key in defaultUserSearchText) {
            if (Object.hasOwnProperty.call(searchText, key)) {
                if (!url[key]) { continue; };
                // if (url[key] === undefined) { continue; };
                url[key] && setSearchText({ ...searchText, [key]: url[key] });

                const filter = {};
                filter.id = i;
                const obj = typesToFilter.find(type => type.value.label === key);
                filter.property = obj.value;

                if (filter.property.type === 'text') {
                    filter.value = url[key];
                }

                if (filter.property.type === 'select') {
                    const datos = obj.value.data.find(data => data.value.id === Number(url[key]));
                    filter.value = datos.value;
                }

                list.push(filter);
            }
            i++;
        }
        if (!list.length) return [{ id: 0, property: { type: 'text', label: '' }, value: '' }];
        return list;
    };

    // *** URL ***
    // 2) se usa cuando se cambian el orden o el tamaño de la paginación y cuando apreto el botón buscar
    // URL is updating from states and usersUIProps (useContext)
    const changeURL = (filters) => {
        // set or delete Dates
        setOrDeleteParams(params, 'dateFrom', date[0]);
        setOrDeleteParams(params, 'dateTo', date[1]);

        // set fiters by sortOder, sortField, pageNumber and pageSize
        for (const key in paymentMovementsUIProps.queryParams) {
            if (key === 'url' || key === 'filters') continue;
            setOrDeleteParams(params, key, paymentMovementsUIProps.queryParams[key]);
        };

        // Deleted old filter queries
        for (const key in defaultUserSearchText) {
            if (Object.hasOwnProperty.call(searchText, key)) {
                params.delete(key);
            }
        }

        // set filter queries
        for (let i = 0; i < filters.length; i++) {
            const element = filters[i];
            const valueToFilter = element.property.type === 'select' ? element.value?.id : element.value;
            setOrDeleteParams(params, element.property.label, valueToFilter);
        }
        searchInputText(params);
        updatePath(params);
    };

    const updatePath = (params) => {
        history.push(`${window.location.pathname}?${params.toString()}`);
    };

    const parseSearch = (value) => {
        const parsedInput = value.replace(/["' /#!$%^&*;:{}=\-_`~()¿?¡]/g, '');
        setSearch(parsedInput);
    };

    const getTranslatedFilter = (filter) => {
        return filter.map((currentFilter, i) => (
            {
                ...currentFilter,
                label: t(`paymentMovements.table.filter.${i}.title`),
                value: {
                    ...currentFilter.value,
                    data: currentFilter.value.data.map((filData, b) => ({ ...filData, label: t(`paymentMovements.table.filter.${i}.${b}`) }))
                }
            }
        ));
    };

    // URL is read for the only time when starting the component
    // then handleFilterSearch users and update states
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => uniqueFilter(), [window.location.href]);

    const toggleFiltersDialog = () => setShowFiltersDialog(!showFiltersDialog);
    // Main Component

    return (
        <>
            <ConfirmModal
                show={openConfirmModal}
                setOpenConfirmModal={setOpenConfirmModal}
            />
            {/* Modal filters */}
            <ClientsFiltersModal
                open={showFiltersDialog}
                onClose={() => setShowFiltersDialog(false)}
                date={date}
                setDate={setDate}
                filtersList={filtersList}
                handleAddFilter={handleAddFilter}
                handleRemoveFilter={handleRemoveFilter}
                handleFilterInputChange={handleFilterInputChange}
                typesToFilter={typesToFilter}
                handleSearch={handleSearch}
                propertiesToFilter={getTranslatedFilter(propertiesToFilter)}
                handleCleanFilters={handleCleanFilters}
                height={'500px'}
                bottomTop={'10px'}
            />
            <FiltersSection
                searchText={search}
                handleChangeSearchText={parseSearch}
                applyFilter={handleSearch}
                toggleFiltersDialog={toggleFiltersDialog}
                UIProps={paymentMovementsUIProps}
                disableButton={paymentMovementsUIProps.isLoading}
            />
        </>
    );
});
export default PaymentMovementsFilters;
